import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const ContainerInfo = styled.div`
  width: 100%;
  padding: 0 .4rem 0 .4rem;
`

export const ContainerType = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  padding: .5rem .3rem .7rem .3rem;
`

export const ContainerBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 .4rem 0 .4rem;
  width: 100%;
  height: 2.5rem;
`

export const CustomTextField = styled(TextFieldMui)`
  width: 100%;
`

export const ConfirmModalContainer = styled.span`
  display: grid;
`

export const ConfirmModalText = styled.label`
  font-size: 15px;
`

export const ConfirmModalConfirmationText = styled.label`
  font-size: 15px;
  font-weight: bold;
  text-align: end;
  margin-top: 10px !important;
`
